import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'app-inventory-resource-unlock',
    templateUrl: './resource-unlock.component.pug',
    styleUrls: ['./resource-unlock.component.less']
})
export class ResourceUnlockComponent {
    @Input() data: any = {};

    constructor(
    ) {
    }
}
